"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-one/sections/headerOne.tsx */

import { LandingSiteTemplateGetDataMenuOutputApiModel } from "@/Apis/ClinicApi";
import { LanguageSelector, SmartImage, SmartLink } from "@/Components";
import { useResponsive } from "@/Hooks";
import HeaderNav from "../../Components/HeaderNav";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode, MouseEventHandler } from "react";

type HeaderOneSupport3sItem = {
    key: Key | null | undefined;
    /** Detected variants: "support-item mb-3" | "support-item" */
    className: string;
    /** Detected variants: "isax isax-messages-3" | "isax isax-call-calling" */
    i0ClassName: string;
    /** Detected variants: "info@example.com" | "+1 24565 89856" */
    h50Text: ReactNode;
    /** Detected variants: "General Inquiries" | "Emergency Cases" */
    p0Text: ReactNode;
    /** Detected variants: "avatar avatar-lg bg-primary rounded-circle" */
    div0ClassName?: string;
    /** Detected variants: "link" */
    h50ClassName?: string;
    /** Detected variants: "title" */
    p0ClassName?: string;
};

type HeaderOneDivs2Item = {
    key: Key | null | undefined;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-instagram" | "fa-brands fa-linkedin" */
    className: string;
    /** Detected variants: "#" */
    href?: string;
};

type HeaderOneDivsItem = {
    key: Key | null | undefined;
    /** Detected variants: "info@example.com" | "+1 66589 14556" */
    pText: ReactNode;
    /** Detected variants: "isax isax-message-text5 me-1" | "isax isax-call5 me-1" */
    className: string;
};

type HeaderOneUls3Item = {
    key: Key | null | undefined;
    /** Detected variants: "btn btn-md btn-primary-gradient" | "btn btn-md btn-dark" */
    className: string;
    /** Detected variants: "all_routes.login" | "all_routes.register" */
    href: string;
    /** Detected variants: "isax isax-lock-1 me-2" | "isax isax-user-tick me-2" */
    i0ClassName: string;
    /** Detected variants: "Sign Up" | "Register" */
    span0Text: ReactNode;
};

type HeaderOneUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "ENG" | "ARA" | "FRA" */
    link0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/flags/us-flag.svg" | "/Templates/Doccure/img/flags/arab-flag.svg" | "/Templates/Doccure/img/flags/france-flag.svg" */
    src: string;
    /** Detected variants: "dropdown-item rounded d-flex align-items-center" */
    className?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "flag" */
    alt?: string;
    /** Detected variants: "me-2" */
    imageWithBasePath0ClassName?: string;
};

type HeaderOneUls2Item = {
    key: Key | null | undefined;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-instagram" | "fa-brands fa-linkedin" */
    className: string;
    /** Detected variants: "social-icon" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeOneHeaderOneGeneratedProps = {
    menus: LandingSiteTemplateGetDataMenuOutputApiModel[];
    isScrolled?: boolean;
    onMobileBtn?: MouseEventHandler<HTMLAnchorElement>;
    onMenuClose?: MouseEventHandler<HTMLAnchorElement>;
    /** Default: false */
    divDiv0Div0Ul0Li0Div0Link0LinkAriaExpanded?: boolean;
    /** Default: "dropdown" */
    divDiv0Div0Ul0Li0Div0Link0LinkDataBsToggle?: string;
    /** Default: "#" */
    divDiv0Div0Ul0Li0Div0Link0LinkHref?: string;
    /** Default: "ENG" */
    divDiv0Div0Ul0Li0Div0Link0LinkText?: ReactNode;
    /** Default: "flag" */
    divDiv0Div0Ul0Li0Div0Link0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/flags/us-flag.svg" */
    divDiv0Div0Ul0Li0Div0Link0ImageWithBasePath0ImageSrc?: string;
    divDiv1H50H5Props?: Partial<ComponentProps<"h5">> | ((item: HeaderOneSupport3sItem) => Partial<ComponentProps<"h5">>);
    /** Default: "#" */
    headerDiv0Nav0Div0Link0LinkHref?: string;
    /** Default: "mobile_btn" */
    headerDiv0Nav0Div0Link0LinkId?: string;
    headerDiv0Nav0Div0Link0LinkVisible?: boolean;
    headerDiv0Nav0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.home" */
    headerDiv0Nav0Div0Link1LinkHref?: string;
    headerDiv0Nav0Div0Link1LinkVisible?: boolean;
    headerDiv0Nav0Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Logo" */
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo.svg" */
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageSrc?: string;
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageVisible?: boolean;
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "all_routes.home" */
    headerDiv0Nav0Div1Div0Div0Link0LinkHref?: string;
    headerDiv0Nav0Div1Div0Div0Link0LinkVisible?: boolean;
    headerDiv0Nav0Div1Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Logo" */
    headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo.svg" */
    headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageSrc?: string;
    headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageVisible?: boolean;
    headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "#" */
    headerDiv0Nav0Div1Div0Div0Link1LinkHref?: string;
    /** Default: "menu_close" */
    headerDiv0Nav0Div1Div0Div0Link1LinkId?: string;
    headerDiv0Nav0Div1Div0Div0Link1LinkVisible?: boolean;
    headerDiv0Nav0Div1Div0Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Contact Information" */
    headerDiv0Nav0Div1Div0Div1Div0H30H3Text?: ReactNode;
    headerDiv0Nav0Div1Div0Div1Div0H30H3Visible?: boolean;
    headerDiv0Nav0Div1Div0Div1Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Div1Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "Follow Us" */
    headerDiv0Nav0Div1Div0Div1Div1H30H3Text?: ReactNode;
    headerDiv0Nav0Div1Div0Div1Div1H30H3Visible?: boolean;
    headerDiv0Nav0Div1Div0Div1Div1H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Div1Div1H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "all_routes.login" */
    headerDiv0Nav0Div1Div0Div1Div2Link0LinkHref?: string;
    /** Default: "Sign In" */
    headerDiv0Nav0Div1Div0Div1Div2Link0LinkText?: ReactNode;
    headerDiv0Nav0Div1Div0Div1Div2Link0LinkVisible?: boolean;
    headerDiv0Nav0Div1Div0Div1Div2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Div1Div2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.register" */
    headerDiv0Nav0Div1Div0Div1Div2Link1LinkHref?: string;
    /** Default: "Sign Up" */
    headerDiv0Nav0Div1Div0Div1Div2Link1LinkText?: ReactNode;
    headerDiv0Nav0Div1Div0Div1Div2Link1LinkVisible?: boolean;
    headerDiv0Nav0Div1Div0Div1Div2Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Div1Div2Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "#support_item" */
    headerDiv0Nav0Ul0Li2Link0LinkDataBsTarget?: string;
    /** Default: "offcanvas" */
    headerDiv0Nav0Ul0Li2Link0LinkDataBsToggle?: string;
    /** Default: "#" */
    headerDiv0Nav0Ul0Li2Link0LinkHref?: string;
    headerDiv0Nav0Ul0Li2Link0LinkVisible?: boolean;
    headerDiv0Nav0Ul0Li2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Ul0Li2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    headerOneUls3LiLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HeaderOneUls3Item) => Partial<ComponentProps<typeof SmartLink>>);
    liLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HeaderOneUls2Item) => Partial<ComponentProps<typeof SmartLink>>);
    linkLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HeaderOneDivs2Item) => Partial<ComponentProps<typeof SmartLink>>);
    headerOneSupport3s: HeaderOneSupport3sItem[];
    headerOneDivs2: HeaderOneDivs2Item[];
    headerOneDivs: HeaderOneDivsItem[];
    headerOneUls3: HeaderOneUls3Item[];
    headerOneUls: HeaderOneUlsItem[];
    headerOneUls2: HeaderOneUls2Item[];
    headerOneSupport3sItemWrapper?: (item: HeaderOneSupport3sItem, content: ReactNode) => ReactNode;
    headerOneSupport3sRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerOneSupport3sH5Visible?: boolean;
    headerOneSupport3sH5Renderer?: (item: HeaderOneSupport3sItem, defaultNode: ReactNode) => ReactNode;
    headerOneSupport3sH5Props?: Partial<ComponentProps<"h5">> | ((item: HeaderOneSupport3sItem) => Partial<ComponentProps<"h5">>);
    headerOneDivs2ItemWrapper?: (item: HeaderOneDivs2Item, content: ReactNode) => ReactNode;
    headerOneDivs2Renderer?: (defaultNode: ReactNode) => ReactNode;
    headerOneDivs2LinkVisible?: boolean;
    headerOneDivs2LinkRenderer?: (item: HeaderOneDivs2Item, defaultNode: ReactNode) => ReactNode;
    headerOneDivs2LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HeaderOneDivs2Item) => Partial<ComponentProps<typeof SmartLink>>);
    headerOneDivsItemWrapper?: (item: HeaderOneDivsItem, content: ReactNode) => ReactNode;
    headerOneDivsRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerOneUls3ItemWrapper?: (item: HeaderOneUls3Item, content: ReactNode) => ReactNode;
    headerOneUls3Renderer?: (defaultNode: ReactNode) => ReactNode;
    headerOneUls3LinkVisible?: boolean;
    headerOneUls3LinkRenderer?: (item: HeaderOneUls3Item, defaultNode: ReactNode) => ReactNode;
    headerOneUls3LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HeaderOneUls3Item) => Partial<ComponentProps<typeof SmartLink>>);
    headerOneUlsItemWrapper?: (item: HeaderOneUlsItem, content: ReactNode) => ReactNode;
    headerOneUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerOneUls2ItemWrapper?: (item: HeaderOneUls2Item, content: ReactNode) => ReactNode;
    headerOneUls2Renderer?: (defaultNode: ReactNode) => ReactNode;
    headerOneUls2LinkVisible?: boolean;
    headerOneUls2LinkRenderer?: (item: HeaderOneUls2Item, defaultNode: ReactNode) => ReactNode;
    headerOneUls2LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HeaderOneUls2Item) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeOneHeaderOneGenerated: FC<HomeOneHeaderOneGeneratedProps> = ({
    menus,
    isScrolled,
    onMobileBtn,
    onMenuClose,
    divDiv0Div0Ul0Li0Div0Link0ImageWithBasePath0ImageAlt = "flag",
    divDiv0Div0Ul0Li0Div0Link0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/flags/us-flag.svg",
    divDiv0Div0Ul0Li0Div0Link0LinkAriaExpanded = false,
    divDiv0Div0Ul0Li0Div0Link0LinkDataBsToggle = "dropdown",
    divDiv0Div0Ul0Li0Div0Link0LinkHref = "#",
    divDiv0Div0Ul0Li0Div0Link0LinkText = "ENG",
    headerDiv0Nav0Div0Link0LinkHref = "#",
    headerDiv0Nav0Div0Link0LinkId = "mobile_btn",
    headerDiv0Nav0Div0Link0LinkVisible,
    headerDiv0Nav0Div0Link0LinkRenderer,
    headerDiv0Nav0Div0Link0LinkProps,
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageAlt = "Logo",
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo.svg",
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageVisible,
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageRenderer,
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageProps,
    headerDiv0Nav0Div0Link1LinkHref = "all_routes.home",
    headerDiv0Nav0Div0Link1LinkVisible,
    headerDiv0Nav0Div0Link1LinkRenderer,
    headerDiv0Nav0Div0Link1LinkProps,
    headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageAlt = "Logo",
    headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo.svg",
    headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageVisible,
    headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageRenderer,
    headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageProps,
    headerDiv0Nav0Div1Div0Div0Link0LinkHref = "all_routes.home",
    headerDiv0Nav0Div1Div0Div0Link0LinkVisible,
    headerDiv0Nav0Div1Div0Div0Link0LinkRenderer,
    headerDiv0Nav0Div1Div0Div0Link0LinkProps,
    headerDiv0Nav0Div1Div0Div0Link1LinkHref = "#",
    headerDiv0Nav0Div1Div0Div0Link1LinkId = "menu_close",
    headerDiv0Nav0Div1Div0Div0Link1LinkVisible,
    headerDiv0Nav0Div1Div0Div0Link1LinkRenderer,
    headerDiv0Nav0Div1Div0Div0Link1LinkProps,
    headerDiv0Nav0Div1Div0Div1Div0H30H3Text = "Contact Information",
    headerDiv0Nav0Div1Div0Div1Div0H30H3Visible,
    headerDiv0Nav0Div1Div0Div1Div0H30H3Renderer,
    headerDiv0Nav0Div1Div0Div1Div0H30H3Props,
    headerDiv0Nav0Div1Div0Div1Div1H30H3Text = "Follow Us",
    headerDiv0Nav0Div1Div0Div1Div1H30H3Visible,
    headerDiv0Nav0Div1Div0Div1Div1H30H3Renderer,
    headerDiv0Nav0Div1Div0Div1Div1H30H3Props,
    headerDiv0Nav0Div1Div0Div1Div2Link0LinkHref = "all_routes.login",
    headerDiv0Nav0Div1Div0Div1Div2Link0LinkText = "Sign In",
    headerDiv0Nav0Div1Div0Div1Div2Link0LinkVisible,
    headerDiv0Nav0Div1Div0Div1Div2Link0LinkRenderer,
    headerDiv0Nav0Div1Div0Div1Div2Link0LinkProps,
    headerDiv0Nav0Div1Div0Div1Div2Link1LinkHref = "all_routes.register",
    headerDiv0Nav0Div1Div0Div1Div2Link1LinkText = "Sign Up",
    headerDiv0Nav0Div1Div0Div1Div2Link1LinkVisible,
    headerDiv0Nav0Div1Div0Div1Div2Link1LinkRenderer,
    headerDiv0Nav0Div1Div0Div1Div2Link1LinkProps,
    headerDiv0Nav0Ul0Li2Link0LinkDataBsTarget = "#support_item",
    headerDiv0Nav0Ul0Li2Link0LinkDataBsToggle = "offcanvas",
    headerDiv0Nav0Ul0Li2Link0LinkHref = "#",
    headerDiv0Nav0Ul0Li2Link0LinkVisible,
    headerDiv0Nav0Ul0Li2Link0LinkRenderer,
    headerDiv0Nav0Ul0Li2Link0LinkProps,
    divDiv1H50H5Props,
    headerOneUls3LiLink0LinkProps,
    liLink0LinkProps,
    linkLinkProps,
    headerOneSupport3s,
    headerOneDivs2,
    headerOneDivs,
    headerOneUls3,
    headerOneUls,
    headerOneUls2,
    headerOneSupport3sItemWrapper,
    headerOneSupport3sRenderer,
    headerOneSupport3sH5Visible,
    headerOneSupport3sH5Renderer,
    headerOneSupport3sH5Props,
    headerOneDivs2ItemWrapper,
    headerOneDivs2Renderer,
    headerOneDivs2LinkVisible,
    headerOneDivs2LinkRenderer,
    headerOneDivs2LinkProps,
    headerOneDivsItemWrapper,
    headerOneDivsRenderer,
    headerOneUls3ItemWrapper,
    headerOneUls3Renderer,
    headerOneUls3LinkVisible,
    headerOneUls3LinkRenderer,
    headerOneUls3LinkProps,
    headerOneUlsItemWrapper,
    headerOneUlsRenderer,
    headerOneUls2ItemWrapper,
    headerOneUls2Renderer,
    headerOneUls2LinkVisible,
    headerOneUls2LinkRenderer,
    headerOneUls2LinkProps,
}) => {
    const { isMobile } = useResponsive();
    return (
        <>
            <div className="header-topbar">
                <div className="container">
                    <div className="topbar-info">
                        <div className="header-info">
                            {renderCollectionNode(
                                headerOneDivs,
                                (item: HeaderOneDivsItem) => (
                                    <p key={item.key}>
                                        <i className={item.className} />
                                        {item.pText}
                                    </p>
                                ),
                                headerOneDivsItemWrapper,
                                headerOneDivsRenderer
                            )}
                        </div>
                        <ul>
                            <li className="drop-header">
                                <LanguageSelector iconOnly={isMobile} />
                            </li>
                            <li className="social-header">
                                <div className="social-icon">
                                    {renderCollectionNode(
                                        headerOneDivs2,
                                        (item: HeaderOneDivs2Item) => (
                                            renderItemNode(headerOneDivs2LinkVisible, headerOneDivs2LinkRenderer, item, (
                                                <SmartLink href={item.href ?? "#"} {...(typeof headerOneDivs2LinkProps === "function" ? headerOneDivs2LinkProps(item) : (headerOneDivs2LinkProps ?? {}))} {...(typeof linkLinkProps === "function" ? linkLinkProps(item) : (linkLinkProps ?? {}))} key={item.key}>
                                                    <i className={item.className} />
                                                </SmartLink>
                                            ))
                                        ),
                                        headerOneDivs2ItemWrapper,
                                        headerOneDivs2Renderer
                                    )}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <header className={isScrolled ? "header header-default fixed" : "header header-default"}>
                <div className="container">
                    <nav className="navbar navbar-expand-lg header-nav">
                        <div className="navbar-header">
                            {renderNode(headerDiv0Nav0Div0Link0LinkVisible, headerDiv0Nav0Div0Link0LinkRenderer, (
                                <SmartLink id={headerDiv0Nav0Div0Link0LinkId} href={headerDiv0Nav0Div0Link0LinkHref} onClick={onMobileBtn} {...(headerDiv0Nav0Div0Link0LinkProps ?? {})}>
                                    <i className="fa-solid fa-bars" />
                                </SmartLink>
                            ))}
                            {renderNode(headerDiv0Nav0Div0Link1LinkVisible, headerDiv0Nav0Div0Link1LinkRenderer, (
                                <SmartLink href={headerDiv0Nav0Div0Link1LinkHref} className="navbar-brand logo" {...(headerDiv0Nav0Div0Link1LinkProps ?? {})}>
                                    {renderNode(headerDiv0Nav0Div0Link1ImageWithBasePath0ImageVisible, headerDiv0Nav0Div0Link1ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={headerDiv0Nav0Div0Link1ImageWithBasePath0ImageSrc} className="img-fluid" alt={headerDiv0Nav0Div0Link1ImageWithBasePath0ImageAlt} {...(headerDiv0Nav0Div0Link1ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </SmartLink>
                            ))}
                        </div>
                        <div className="header-menu">
                            <div className="main-menu-wrapper">
                                <div className="menu-header">
                                    {renderNode(headerDiv0Nav0Div1Div0Div0Link0LinkVisible, headerDiv0Nav0Div1Div0Div0Link0LinkRenderer, (
                                        <SmartLink href={headerDiv0Nav0Div1Div0Div0Link0LinkHref} className="menu-logo" {...(headerDiv0Nav0Div1Div0Div0Link0LinkProps ?? {})}>
                                            {renderNode(headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageVisible, headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageRenderer, (
                                                <SmartImage src={headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageSrc} className="img-fluid" alt={headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageAlt} {...(headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageProps ?? {})} />
                                            ))}
                                        </SmartLink>
                                    ))}
                                    {renderNode(headerDiv0Nav0Div1Div0Div0Link1LinkVisible, headerDiv0Nav0Div1Div0Div0Link1LinkRenderer, (
                                        <SmartLink id={headerDiv0Nav0Div1Div0Div0Link1LinkId} className="menu-close" href={headerDiv0Nav0Div1Div0Div0Link1LinkHref} onClick={onMenuClose} {...(headerDiv0Nav0Div1Div0Div0Link1LinkProps ?? {})}>
                                            <i className="fas fa-times" />
                                        </SmartLink>
                                    ))}
                                </div>
                                <HeaderNav menus={menus} />
                                <div className="header-items">
                                    <div className="about-popup-item border-0 pb-0">
                                        {renderNode(headerDiv0Nav0Div1Div0Div1Div0H30H3Visible, headerDiv0Nav0Div1Div0Div1Div0H30H3Renderer, (
                                            <h3 className="title" {...(headerDiv0Nav0Div1Div0Div1Div0H30H3Props ?? {})}>{headerDiv0Nav0Div1Div0Div1Div0H30H3Text}</h3>
                                        ))}
                                        {renderCollectionNode(
                                            headerOneSupport3s,
                                            (item: HeaderOneSupport3sItem) => (
                                                <div className={item.className} key={item.key}>
                                                    <div className={item.div0ClassName ?? "avatar avatar-lg bg-primary rounded-circle"}>
                                                        <i className={item.i0ClassName} />
                                                    </div>
                                                    <div>
                                                        <p className={item.p0ClassName ?? "title"}>{item.p0Text}</p>
                                                        {renderItemNode(headerOneSupport3sH5Visible, headerOneSupport3sH5Renderer, item, (
                                                            <h5 className={item.h50ClassName ?? "link"} {...(typeof headerOneSupport3sH5Props === "function" ? headerOneSupport3sH5Props(item) : (headerOneSupport3sH5Props ?? {}))} {...(typeof divDiv1H50H5Props === "function" ? divDiv1H50H5Props(item) : (divDiv1H50H5Props ?? {}))}>{item.h50Text}</h5>
                                                        ))}
                                                    </div>
                                                </div>
                                            ),
                                            headerOneSupport3sItemWrapper,
                                            headerOneSupport3sRenderer
                                        )}
                                    </div>
                                    <div className="about-popup-item border-0 pb-0">
                                        {renderNode(headerDiv0Nav0Div1Div0Div1Div1H30H3Visible, headerDiv0Nav0Div1Div0Div1Div1H30H3Renderer, (
                                            <h3 className="title" {...(headerDiv0Nav0Div1Div0Div1Div1H30H3Props ?? {})}>{headerDiv0Nav0Div1Div0Div1Div1H30H3Text}</h3>
                                        ))}
                                        <ul className="d-flex align-items-center gap-2 social-iyem">
                                            {renderCollectionNode(
                                                headerOneUls2,
                                                (item: HeaderOneUls2Item) => (
                                                    <li key={item.key}>
                                                        {renderItemNode(headerOneUls2LinkVisible, headerOneUls2LinkRenderer, item, (
                                                            <SmartLink href={item.href ?? "#"} className={item.link0ClassName ?? "social-icon"} {...(typeof headerOneUls2LinkProps === "function" ? headerOneUls2LinkProps(item) : (headerOneUls2LinkProps ?? {}))} {...(typeof liLink0LinkProps === "function" ? liLink0LinkProps(item) : (liLink0LinkProps ?? {}))}>
                                                                <i className={item.className} />
                                                            </SmartLink>
                                                        ))}
                                                    </li>
                                                ),
                                                headerOneUls2ItemWrapper,
                                                headerOneUls2Renderer
                                            )}
                                        </ul>
                                    </div>
                                    <div className="header-items-button">
                                        {renderNode(headerDiv0Nav0Div1Div0Div1Div2Link0LinkVisible, headerDiv0Nav0Div1Div0Div1Div2Link0LinkRenderer, (
                                            <SmartLink href={headerDiv0Nav0Div1Div0Div1Div2Link0LinkHref} className="btn btn-primary btn-primary-gradient" {...(headerDiv0Nav0Div1Div0Div1Div2Link0LinkProps ?? {})}>
                                                <i className="isax isax-lock-1 me-2" />
                                                {headerDiv0Nav0Div1Div0Div1Div2Link0LinkText}
                                            </SmartLink>
                                        ))}
                                        {renderNode(headerDiv0Nav0Div1Div0Div1Div2Link1LinkVisible, headerDiv0Nav0Div1Div0Div1Div2Link1LinkRenderer, (
                                            <SmartLink href={headerDiv0Nav0Div1Div0Div1Div2Link1LinkHref} className="btn btn-dark" {...(headerDiv0Nav0Div1Div0Div1Div2Link1LinkProps ?? {})}>
                                                <i className="isax isax-user-tick4 me-2" />
                                                {headerDiv0Nav0Div1Div0Div1Div2Link1LinkText}
                                            </SmartLink>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ul className="nav header-navbar-rht">
                            {renderCollectionNode(
                                headerOneUls3,
                                (item: HeaderOneUls3Item) => (
                                    <li key={item.key}>
                                        {renderItemNode(headerOneUls3LinkVisible, headerOneUls3LinkRenderer, item, (
                                            <SmartLink href={item.href} className={item.className} {...(typeof headerOneUls3LinkProps === "function" ? headerOneUls3LinkProps(item) : (headerOneUls3LinkProps ?? {}))} {...(typeof headerOneUls3LiLink0LinkProps === "function" ? headerOneUls3LiLink0LinkProps(item) : (headerOneUls3LiLink0LinkProps ?? {}))}>
                                                <i className={item.i0ClassName} />
                                                <span>{item.span0Text}</span>
                                            </SmartLink>
                                        ))}
                                    </li>
                                ),
                                headerOneUls3ItemWrapper,
                                headerOneUls3Renderer
                            )}
                            <li>
                                {renderNode(headerDiv0Nav0Ul0Li2Link0LinkVisible, headerDiv0Nav0Ul0Li2Link0LinkRenderer, (
                                    <SmartLink href={headerDiv0Nav0Ul0Li2Link0LinkHref} className="details-btn" data-bs-toggle={headerDiv0Nav0Ul0Li2Link0LinkDataBsToggle} data-bs-target={headerDiv0Nav0Ul0Li2Link0LinkDataBsTarget} {...(headerDiv0Nav0Ul0Li2Link0LinkProps ?? {})}>
                                        <i className="isax isax-menu5" />
                                    </SmartLink>
                                ))}
                            </li>
                        </ul>
                    </nav>
                </div>
            </header>
        </>
    );
};

export default HomeOneHeaderOneGenerated;
